import { Pipe, PipeTransform } from '@angular/core';

import { formatAmount, toAmount } from './amount-input.directive';

/**
 * Display counterpart of `appAmountInput`: 1250000.5 → "1,250,000.5".
 * Empty values give '' and anything that is not a number is returned as it
 * is, so (unlike the `number` pipe) it never throws on unexpected text.
 *
 *   {{ (value | amount) || '-' }}
 */
@Pipe({
  name: 'amount',
  standalone: true,
})
export class AmountPipe implements PipeTransform {
  transform(value: unknown, decimals = 2): string {
    const amount = toAmount(value);

    if (amount === null) {
      return value === null || value === undefined ? '' : String(value);
    }

    return formatAmount(amount, decimals);
  }
}
